// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"7e872cf1","231":"ea303a7a","376":"0369f0d7","702":"9ed18f5e","914":"a63e576f"}[chunkId] + ".chunk.js";
};